import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SettingProvider } from '../../providers/SettingProvider';
import { ServiceProvider } from '../../providers/ServiceProvider';
import { SessionProvider } from '../../providers/SessionProvider';
import { LoginPage } from '../Login/Login';

/*
  Generated class for the Setting page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-Setting',
    templateUrl: 'Setting.html'
})
export class SettingPage {
    Setting: any = {};
    constructor(public navCtrl: NavController, public navParams: NavParams, public settingProvider: SettingProvider, public serviceProvider: ServiceProvider, public sessionProvider: SessionProvider) { }

    ionViewWillEnter() {
        this.Setting = this.settingProvider.getSetting();
    }
    SaveSetting() {
        this.settingProvider.setSetting(this.Setting);
        this.ionViewWillEnter();
    }
    RemoveCompany(value) {
        this.settingProvider.RemoveCompany(value);
        this.ionViewWillEnter();
    }
    removeAllCompanie() {
        this.Setting.Companies.splice(0, this.Setting.Companies.length);
        this.SaveSetting();
    }
    addAllCompanies() {
        if (this.sessionProvider.getToken() != null) {
            this.Setting.Companies.splice(0, this.Setting.Companies.length);
            this.serviceProvider.Get("/IspaCompanyList?tMDId61_Region=null&tDataComboId1=null&cuName=null&Id=", true).then((result) => {
                let companies: any = result;
                companies.forEach((company, index) => {
                    this.Setting.Companies.push(company);
                });
                this.SaveSetting();
            });
        }
        else {
            this.navCtrl.push(LoginPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/Setting/Setting.ts